export const FEATURE_NAME = '@zerops/zerops/feature/remote-repository-connector';
export const FEATURE_GITHUB_FORM = '@zerops/zerops/feature/remote-repository-connector/github-form';
export const FEATURE_GITLAB_FORM = '@zerops/zerops/feature/remote-repository-connector/gitlab-form';
